import type { MutateOptions } from '@tanstack/react-query';

import { SAM_AVAILABLE_LANGUAGES } from '../../domain/insight';
import type { UserSettings, UserSettingsKey } from '../../domain/user';
import { SAM_LANGUAGE_CODE } from '../../domain/user';

import { useUserQuery } from './useUserQuery';
import { useUserSettingsMutation } from './useUserSettingsMutation';

export function useUserSettings() {
  const { data: user, isLoading, isError } = useUserQuery();
  const userSettingsMutation = useUserSettingsMutation();

  const getUserSetting = <T extends UserSettingsKey>(key: T): UserSettings[T] | undefined => user?.userSettings?.[key];

  const setUserSettings = (
    setting: Partial<UserSettings>,
    options?: MutateOptions<void, void, Partial<UserSettings>>
  ) => {
    userSettingsMutation.mutate(setting, options);
  };

  const getUserSAMLanguageCode = (): string => {
    const languageCode = getUserSetting(SAM_LANGUAGE_CODE);

    return typeof languageCode === 'string' && SAM_AVAILABLE_LANGUAGES.some(({ id }) => id === languageCode)
      ? languageCode
      : 'en';
  };

  return {
    getUserSetting,
    getUserSAMLanguageCode,
    setUserSettings,
    isLoading,
    isError,
  };
}
